/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { useGlobalContext } from '../../../context/ContextGlobal'
import useCollaborator from './useCollaborator'
import { EncryptCard } from '../../../api/pagBank/encrypt'
import { getAddressByCep } from '../../../utils/consultingCEP'
import {
  addDocument,
  addSubDocument,
  generateIdSubDocument,
  getDocument,
  getSubDocuments,
  incrementFieldInDocument,
  setSubDocument,
  updateDocument,
  updateSubDocument,
} from '../../../firebase/firestore'
import { TryCatch } from '../../../utils/general'
import { PagBankAssinante, PagBankAssinatura } from '../../../api/pagBank'
import { Path } from '../../../router/paths'
import { DateTimeNow, TimestampNow } from '../../../utils/dates'

const useCollaboratorRegisterPayment = () => {
  const { user, token, Authentication } = useCollaborator()

  const { alerts, setAlerts, setLoading, loading, formContext, setFormContext, setUser } = useGlobalContext()

  const { planId } = useParams()

  const [addressCompleted, setAddressCompleted] = useState(false)
  const [hasEmptyValue, setHasEmptyValue] = useState(true)
  const [hasEmptyContact, setHasEmptyContact] = useState(true)

  const navigate = useNavigate()

  const uid = user.id

  const getForm = async () => {
    await Authentication()

    const getPlan = await getDocument('plans', planId)

    setFormContext((prev) => ({ ...prev, ...getPlan }))
  }

  const FetchGetForm = async () => {
    await TryCatch(getForm, setLoading, setAlerts)
  }

  function formatPhoneNumber(input) {
    const regex = /\((\d{2})\)\s*(\d{5})-(\d{4})/
    const match = input.match(regex)

    if (!match) {
      throw new Error('Formato de telefone inválido')
    }

    const area = `${match[1]}`
    const number = `${match[2]}${match[3]}`

    return {
      area,
      number,
      country: '55',
    }
  }

  const schemaAssinantePagbank = (values) => {
    function formatarData(data) {
      if (typeof data === 'string' && data.includes('/')) {
        const [dia, mes, ano] = data.split('/')
        if (dia.length === 2 && mes.length === 2 && ano.length === 4) {
          return `${ano}-${mes}-${dia}`
        }
      }
      return data
    }

    const newBirthDay = formatarData(values?.personal?.birthday)

    return {
      address: {
        street: values?.address?.street,
        number: values?.address?.number,
        complement: String(values?.address?.complement).replace(/\s+/g, ''),
        locality: values?.address?.district,
        city: values?.address?.city,
        region_code: values?.address?.state,
        postal_code: values?.address?.zipcode,
        country: 'BRA',
      },
      reference_id: values?.id,
      name: String(values?.name).trim(),
      email: String(values?.email).trim(),
      tax_id: String(values?.cpf).replace(/[.-]/g, '').trim(),
      phones: [
        {
          country: values?.phones?.country,
          area: values?.phones?.area,
          number: values?.phones?.number,
        },
      ],
      birth_date: newBirthDay,
      billing_info: [
        {
          card: {
            encrypted: values.cardEncripted,
          },
          type: 'CREDIT_CARD',
        },
      ],
    }
  }

  const createNewAssinantePagBank = async () => {
    const cardEncript = await EncryptCard(formContext, setAlerts)

    if (!cardEncript) return
    const addressUser = {
      street: formContext?.street,
      number: formContext?.number,
      complement: formContext?.complement || 'na',
      district: formContext?.district,
      city: formContext?.city,
      state: formContext?.state,
      zipcode: formContext?.zipcode,
    }

    const phoneUser = formatPhoneNumber(formContext?.phones)

    const dataAssinante = {
      ...user,
      address: addressUser,
      phones: phoneUser,
      cardEncripted: cardEncript,
    }

    const newSchemaAssinante = schemaAssinantePagbank(dataAssinante)

    let newAssinante

    const consultAssinante = await PagBankAssinante().consult(null, newSchemaAssinante.tax_id)

    if ([...(consultAssinante?.customers || [])].length > 0) {
      const idConsult = consultAssinante?.customers?.[0]?.id
      newAssinante = await PagBankAssinante().editPayment(idConsult, newSchemaAssinante?.billing_info)
    } else {
      try {
        newAssinante = await PagBankAssinante().add(newSchemaAssinante)
      } catch (e) {
        console.error(e.message)
      }
    }

    const newUpdateCollab = {
      idPagBank: newAssinante?.id,
    }

    setUser((prev) => ({ ...prev, ...newUpdateCollab }))

    await updateDocument('colaboradores', user.id, newUpdateCollab)

    await setFormContext((prev) => ({
      ...prev,
      newAssinante,
    }))

    return navigate(Path.CollabRegisterPaymentResume(token, planId))
  }

  const HandleCreateNewAssinantePagBank = async () => {
    await TryCatch(createNewAssinantePagBank, setLoading, setAlerts)
  }

  // Objeto com as bandeiras dos cartões
  // OBS: salvar os PNG na pasta public/bandeira-cartao
  const bandeiras = [
    {
      id: '0',
      banco: '',
      path: '',
    },
    {
      id: '1',
      banco: 'Logo Mastercard',
      path: '/bandeira-cartao/mc_symbol_opt_53_1x.png',
    },
    {
      id: '2',
      banco: 'Logo Visa',
      path: '/bandeira-cartao/visa-17.png',
    },
    {
      id: '3',
      banco: 'Logo American Express',
      path: '/bandeira-cartao/american-express-28.png',
    },
    {
      id: '4',
      banco: 'Logo Elo',
      path: '/bandeira-cartao/elo-30.png',
    },
  ]

  // Função para verficar a bandeira pelos numeros iniciais
  const getCardBrand = (number) => {
    const sanitized = number.replace(/\D/g, '')
    if (/^5[1-5]/.test(sanitized)) {
      return '1'
    }
    if (/^(4011|4312|4389|4514)/.test(sanitized)) {
      return '4'
    }
    if (/^4/.test(sanitized)) {
      return '2'
    }
    if (/^3[47]/.test(sanitized)) {
      return '3'
    }

    return '0'
  }

  const formatCardNumber = (number) => {
    if (!number) return '•••• •••• •••• ••••'
    const digits = number.replace(/\D/g, '')
    const groups = []
    for (let i = 0; i < digits.length && i < 16; i += 4) {
      groups.push(digits.slice(i, i + 4))
    }
    return groups.join(' ').padEnd(19, '•')
  }

  const formatExpiryDate = (date) => {
    if (!date) return 'MM/AAAA'
    return date
  }

  const checkingEmptyAddress = async () => {
    const hasCompleteAddress = Object.values(user?.address || {}).every(
      (value) => value !== '' && value !== null && value !== undefined,
    )
    // const contact = Object.values(formContext.phones).some((value) => {
    //   return value === '' || value === null || value === undefined
    // })
    setHasEmptyValue(hasCompleteAddress)
    return hasCompleteAddress
  }

  const CreateNewAssinatureRecurrence = async () => {
    const plan = formContext

    // coleta usuario atualizado
    const getUser = await getDocument('colaboradores', uid)

    // cancela planos existentes
    const getPlansInCollab = await getSubDocuments('colaboradores', uid, 'plans')
    const newPlansCanceleds = getPlansInCollab.map(async (p) => {
      const subscriptionId = p.subscriptionId

      // tenta cancelar assinatura no pagbank
      try {
        await PagBankAssinatura().cancel(subscriptionId, {})
      } catch (e) {
        console.error(e.message)
      }

      await updateSubDocument('colaboradores', uid, 'plans', p.id, {
        status: 'canceled',
      })
    })
    await Promise.all(newPlansCanceleds)

    const creditInfo = {
      ...plan?.newAssinante?.billing_info,
    }

    // cria um novo plano
    const newPlan = {
      idPagBank: plan?.idPagBank || '',
      idPlan: plan.id,
      idOmie: plan.idOmie,
      name: plan.name,
      value: plan.value,
      payment: plan.payment,
      recurrence: Number(plan.typeExpired || '30'),
      admission: plan.admission,
      dtJoin: TimestampNow(),
      status: 'active',
      creditInfo,
      ...(plan?.cupomSelected && { cupomSelected: plan?.cupomSelected }),
      // se exitir cupom, anotar que ele foi usado dentro do novo plano
    }

    // aplica lógica de admissionPayment
    const { lastPayment, nextPayment, cupons } = getUser
    const hasTrial = getUser?.hasTrial || false
    const admissionPayment = getUser?.admissionPayment || false
    const trialDays = Number(plan.trialDays || '0')
    const updateCollab = {
      lastPayment,
      nextPayment,
      hasTrial,
    }
    if ((!admissionPayment || !hasTrial) && trialDays > 0) {
      // aplica ao collab o periodo de teste
      updateCollab.hasTrial = true

      // cria nova data de cobraça se possuir gratuidade
      const diasTrial = trialDays * 86400000 // 1 dia = 86.400.000 ms
      const dtStart = Number(newPlan.dtJoin) + diasTrial

      // adiciona o ultimo pagamento para não cobrar
      updateCollab.lastPayment = 0
      updateCollab.nextPayment = dtStart
      updateCollab.dtFreeTrial = dtStart
    } else {
      if (!updateCollab.lastPayment) {
        updateCollab.lastPayment = 0
      }
      if (!updateCollab.nextPayment) {
        updateCollab.nextPayment = TimestampNow()
        updateCollab.dtFreeTrial = TimestampNow()
        // updateCollab.nextPayment = Number(updateCollab.lastPayment) + newPlan.recurrence * 86400000;
      }
    }

    // const criarUserOmie = true
    // // cria um usuario na omie para o colaborador
    // if (criarUserOmie) {
    //   const userOmie = createSchemaColabOmie(user)
    //   let createClientOmie
    //   let consultarCliente = false
    //   let cCodClientOmie = ''

    //   try {
    //     // tenta criar um cliente na omie
    //     consultarCliente = await ClientOmie().consultar(user?.id, user?.cCodClientOmie)
    //   } catch (error) {
    //     console.error(error.message)
    //   }

    //   cCodClientOmie = consultarCliente.codigo_cliente_omie

    //   if (!consultarCliente) {
    //     try {
    //       // tenta criar um cliente na omie
    //       createClientOmie = await ClientOmie().incluirCliente([userOmie])
    //     } catch (error) {
    //       // se eele retornar que ja existe e é um novo cadastro, então segue o fluxo, se não da erro
    //       if (error.message.includes('102')) {
    //         cCodClientOmie = String(error.message).split('nCod')[1].match(/\d+/)[0]
    //       } else if (error.message.includes('101')) {
    //         const errorMessage = String(error.message).toLowerCase()
    //         cCodClientOmie = errorMessage.match(/com o id \[([^\]]+)\]/)[1]
    //       } else {
    //         return setAlerts((prev) => [
    //           ...prev,
    //           {
    //             type: 'error',
    //             title: 'Criação de cadastro não concluído',
    //             msg: 'Ocorreu um erro ao Criação de cadastro, contate o suporte da keap para ajudar a concluir o pagamento.',
    //           },
    //         ])
    //       }
    //     }

    //     if (createClientOmie) {
    //       cCodClientOmie = createClientOmie.codigo_cliente_omie
    //     }
    //   }

    //   // se não deu error, então ele pega o código da omie e atualiza o cadastro do colaborador

    //   if (createClientOmie) {
    //     cCodClientOmie = createClientOmie.codigo_cliente_omie
    //   }
    //   if (!cCodClientOmie) {
    //     return setAlerts((prev) => [
    //       ...prev,
    //       {
    //         type: 'error',
    //         title: 'Criação de cadastro não concluído',
    //         msg: 'Ocorreu um erro ao Criação de cadastro, contate o suporte da keap para ajudar a concluir o pagamento.',
    //       },
    //     ])
    //   }
    //   // atualiza o colaborador com o codigo da omie
    //   await updateDocument('colaboradores', user.id, { cCodClientOmie })
    // }

    // cria e aplica cupon no novo pagamento gerado
    const cupom = formContext?.cupomSelected

    if (!cupons || Object.keys(cupons).length === 0) {
      // cupons está vazio → não adiciona ao updateCollab
      updateCollab.cupons = {
        ...(cupom?.codCupom && { [cupom.codCupom]: true }),
      }
    } else {
      // cupons já tem conteúdo → adiciona novo cupom se houver
      updateCollab.cupons = {
        ...cupons,
        ...(cupom?.codCupom && { [cupom.codCupom]: true }),
      }
    }

    const idPayment = await generateIdSubDocument('colaboradores', uid, 'payments')

    const newPayment = {
      dt_created: DateTimeNow(),
      errors: 0,
      idPayment,
      idPlan: newPlan.idPlan,
      idUser: uid,
      name: newPlan.name,
      status: 'awaitPayment',
      type: updateCollab.lastPayment > 0 ? 'payment' : 'admission',
      typeUser: 'collab',
      typePayment: 'credito',
      value: cupom ? cupom.value : newPlan.value,
      log: [
        {
          status: `Contratação da assinatura recorrente pelo colaborador`,
          time: TimestampNow(),
          origin: 'colaboradores/planSelected',
        },
      ],
      creditInfo,
      ...(plan?.cupomSelected && { cupomSelected: plan?.cupomSelected }),
      lastUpdate: TimestampNow(),
    }

    const newValueAmount = Math.round(Number(newPlan.value) * 100)

    const newAssinaturaData = {
      plan: {
        id: newPlan.idPagBank,
      },
      customer: {
        id: getUser.idPagBank,
      },
      ...(cupom && {
        coupon: {
          id: cupom.idPagBank,
        },
      }),
      amount: {
        value: newValueAmount,
        currency: 'BRL',
      },
      reference_id: idPayment,
      payment_method: [
        {
          type: 'CREDIT_CARD',
          card: {
            security_code: formContext?.cvc,
          },
        },
      ],
      pro_rata: false,
    }

    let criarNovaAssinaturaPagBank

    const now = TimestampNow()
    const nowLastPayment = getUser?.lastPayment ?? null
    const nowNextPayment = getUser?.nextPayment ?? null

    if ((nowLastPayment === null || nowLastPayment >= now) && (nowNextPayment === null || nowNextPayment <= now)) {
      criarNovaAssinaturaPagBank = await PagBankAssinatura().add(newAssinaturaData)
    } else {
      // coleta nova data de pagamento, para criar um cobraça na proxima vez
      const date = new Date(nowNextPayment)

      const dia = date.getDate() // 1 a 31
      // const mes = date.getMonth() + 1

      newAssinaturaData.best_invoice_date = {
        day: String(dia),
        // month: String(mes),
      }

      criarNovaAssinaturaPagBank = await PagBankAssinatura().add(newAssinaturaData)
      newPayment.nextInvoiceAt = criarNovaAssinaturaPagBank.next_invoice_at
    }

    newPayment.subscriptionId = criarNovaAssinaturaPagBank.id
    newPlan.subscriptionId = criarNovaAssinaturaPagBank.id

    // cria novo payment no colaborador
    await setSubDocument('colaboradores', uid, 'payments', idPayment, newPayment)

    // salva novo plano no colaborador
    await setSubDocument('colaboradores', uid, 'plans', newPlan.idPlan, newPlan)

    // aplica no limite do cupom
    if (Object.keys(cupom ?? {}).length > 0) {
      await incrementFieldInDocument('plans', cupom.id, 'apllieds', 1)
    }

    // somente deixa o colaborador seguir se ele escolher um plano
    await updateDocument('colaboradores', uid, { emailVerify: true, typeBilling: 'recurrence', ...updateCollab })

    return navigate(Path.CollabHistorySelected(token, idPayment))
  }

  const HandleCreateNewAssinatureRecurrence = async () => {
    await TryCatch(CreateNewAssinatureRecurrence, setLoading, setAlerts)
  }

  useEffect(() => {
    FetchGetForm()

    checkingEmptyAddress()
  }, [])

  useEffect(() => {
    const fetchAddress = async () => {
      if ((formContext?.zipcode || '').length === 8 && !addressCompleted) {
        const response = await getAddressByCep(formContext?.zipcode)
        if (response.error) {
          setAddressCompleted(false)
          return setAlerts((prev) => [
            ...prev,
            {
              title: 'CEP Inválido',
              msg: 'O CEP inserido não é válido.',
              type: 'error',
            },
          ])
        }
        setFormContext((prev) => ({
          ...prev,
          street: response.logradouro,
          district: response.bairro,
          city: response.localidade,
          state: response.uf,
        }))
        setAddressCompleted(true)
      } else if ((formContext?.zipcode || '').length < 8 && addressCompleted) {
        setAddressCompleted(false)
      }
    }

    fetchAddress()
  }, [formContext?.zipcode, addressCompleted])

  return {
    token,
    planId,
    hasEmptyValue,
    loading,
    bandeiras,
    alerts,
    setAlerts,
    HandleCreateNewAssinantePagBank,
    formContext,
    setFormContext,
    formatCardNumber,
    getCardBrand,
    formatExpiryDate,
    HandleCreateNewAssinatureRecurrence,
  }
}

export default useCollaboratorRegisterPayment
